// @ts-nocheck
// SINGLE SOURCE OF TRUTH for per-wallet SOL funding need. Both the client
// (auto-fill + funding meter) and the server audit (server/execute.ts) use these
// exact constants + formula, so "Fund all wallets" always satisfies the dry run.
import { LAUNCH_NODE_ID, type FlowGraph } from "@/lib/algo/graph";

export const CREATE_BUFFER_SOL = 0.02; // rent + create-tx headroom for the creator
export const FEE_BUFFER_SOL = 0.003;   // per-action fee + priority headroom (≥ executor's rotate sweep reserve)

/** THE one dev/creator rule, used by client + server so funding lands on the
 *  wallet that signs the launch. Stable: an explicit devWalletId, else the FIRST
 *  wallet (Wallet 1). buildPlan pins this into the plan so the executor uses the
 *  exact same wallet — no "first buyer" jumpiness, no wallet shown twice. */
export function resolveDevId(graph: FlowGraph): string | undefined {
  return graph.launch.devWalletId || graph.wallets[0]?.id;
}

/** SOL each wallet must hold for the flow to run. Mirrors audit() in execute.ts:
 *  creator = CREATE_BUFFER + devBuy + FEE; each buy adds (sol + FEE) to the buyer;
 *  each sell / rotate-source adds FEE. Rotate-in buys are funded by the prior sell. */
export function walletFundNeeds(graph: FlowGraph): Map<string, number> {
  const need = new Map<string, number>();
  const add = (id: string, sol: number) => { if (id && id !== LAUNCH_NODE_ID) need.set(id, (need.get(id) ?? 0) + sol); };
  const devId = resolveDevId(graph);
  if (devId) add(devId, CREATE_BUFFER_SOL + (graph.devBuySol || 0) + FEE_BUFFER_SOL);
  for (const e of graph.edges) {
    if (e.kind === "buy") add(e.target, (e.sol || 0) + FEE_BUFFER_SOL);
    else if (e.kind === "rotate") add(e.source, FEE_BUFFER_SOL);
  }
  for (const s of graph.sells) add(s.walletId, FEE_BUFFER_SOL);
  return need;
}

export const totalFundNeed = (graph: FlowGraph): number => [...walletFundNeeds(graph).values()].reduce((s, v) => s + v, 0);
